(function () {
  var MAX_TRIES = 25;
  var TRY_MS = 120;

  function css() {
    if (document.getElementById("havin-visit-vendor-store-css")) return;
    var style = document.createElement("style");
    style.id = "havin-visit-vendor-store-css";
    style.textContent =
      ".havin-visit-vendor-store{display:block;width:100%;margin:.35rem 0 .15rem;line-height:1.3}" +
      ".havin-visit-vendor-store[hidden]{display:none}" +
      ".havin-visit-vendor-store__link{font-size:.875rem;font-weight:500;color:inherit;opacity:.72;text-decoration:none;border-bottom:1px solid transparent}" +
      ".havin-visit-vendor-store__link:hover{opacity:1;border-bottom-color:currentColor}";
    document.head.appendChild(style);
  }

  function isBad(el) {
    return !el || !!el.closest("header, footer, product-form-component, .quick-add, .quick-add-modal");
  }

  function anchorFor(el) {
    if (!el || isBad(el)) return null;
    // Prefer placing after the title link / text-block so the CTA is not nested
    // inside the Pitch product-title <a> wrapper.
    return (
      el.closest('a[ref="productTitleLink"]') ||
      el.closest('a[data-havin-variant-title-link="1"]') ||
      el.closest(".text-block") ||
      el
    );
  }

  function findTitleBlock() {
    // Pitch (post product-title.liquid): title is <p role="heading">, not h1–h6.
    var pitch =
      document.querySelector('.product-details [data-havin-variant-title="1"]') ||
      document.querySelector(
        '.product-details a[ref="productTitleLink"] p[role="heading"]'
      ) ||
      document.querySelector(
        '.product-details a[data-havin-variant-title-link="1"] p[role="heading"]'
      ) ||
      document.querySelector(".product-details .text-block p[role='heading']") ||
      document.querySelector('.product-details a[ref="productTitleLink"]') ||
      document.querySelector(
        '.product-details a[data-havin-variant-title-link="1"]'
      );
    var pitchAnchor = anchorFor(pitch);
    if (pitchAnchor) return pitchAnchor;

    var headings = document.querySelectorAll(
      ".text-block h1, .text-block h2, .text-block h3, .text-block h4, .text-block h5, .text-block h6"
    );
    for (var i = 0; i < headings.length; i++) {
      if (isBad(headings[i])) continue;
      return headings[i].closest(".text-block") || headings[i];
    }
    var fallback = document.querySelector(
      "h1.product-title, .product-title, .product-info h1, .product-information h1"
    );
    return isBad(fallback) ? null : fallback;
  }

  function place(tries) {
    var root = document.getElementById("havin-visit-vendor-store");
    if (!root || root.dataset.placed === "1") return;
    css();
    var title = findTitleBlock();
    if (!title) {
      if (tries < MAX_TRIES) {
        setTimeout(function () {
          place(tries + 1);
        }, TRY_MS);
      }
      return;
    }
    title.insertAdjacentElement("afterend", root);
    root.hidden = false;
    root.removeAttribute("hidden");
    root.dataset.placed = "1";
  }

  function start() {
    place(0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
